const STORAGE_KEY = 'tessa:currency-symbol';
export const CURRENCY_EVENT = 'tessa-currency-change';

export function getCurrencySymbol(): string {
  return localStorage.getItem(STORAGE_KEY) ?? '€';
}

export function setCurrencySymbol(symbol: string): void {
  localStorage.setItem(STORAGE_KEY, symbol);
  window.dispatchEvent(new Event(CURRENCY_EVENT));
}
